<template>
  <div class="eos-missions-page">
    <!-- Back Button -->
    <span @click="$router.back()" class="back-btn">
      <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13 5H1M1 5L5 1M1 5L5 9" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      麦塔之境
    </span>

    <!-- Part 1: Hero -->
    <section class="hero">
      <!-- <div class="hero-fallback"></div> -->
      <video 
        id="HeroVideo"
        class="hero-video" 
        autoplay 
        muted 
        loop 
        playsinline
        :src="videoUrl"
        :poster="`${imgUrlPrefix}video_bg.jpg`"
        @error="$event.target.style.display='none'"
      ></video>
      <div class="hero-overlay"></div>
      <div class="hero-content">
        <div class="hero-eyebrow">METTA · EOS</div>
        <h1 class="hero-title">EOS Missions</h1>
        <p class="hero-sub">
          六项极限任务，横跨荒漠、极地与高原。<br>
          这是麦塔 EOS 的真实试炼。
        </p>
        <div class="hero-scroll">
          <div class="hero-scroll-line"></div>
          探索任务
        </div>
      </div>
    </section>

    <!-- Parts 2–7: Mission Sections -->
    <div id="missions-container">
      <section 
        v-for="(m, index) in missions" 
        :key="m.id"
        class="mission"
        :class="`layout-${m.side}`"
      >
        <!-- Fallback Background -->
        <div 
          class="mission-fallback-bg" 
          :style="{ background: gradients[index].fallback }"
        ></div>
        
        <!-- Image Background -->
        <div 
          class="mission-bg" 
          :style="{ backgroundImage: `url(${imgUrlPrefix}${m.img})` }"
          @error="$event.target.style.backgroundImage='none'"
        ></div>
        
        <!-- Overlay -->
        <div 
          class="mission-overlay" 
          :style="{ background: gradients[index].overlay }"
        ></div>
        
        <!-- Content -->
        <div class="mission-content">
          <div class="mission-num reveal">{{ m.label }}</div>
          <h2 class="mission-title reveal" :style="{ transitionDelay: '0.08s' }">{{ m.title }}</h2>
          <p class="mission-desc reveal" :style="{ transitionDelay: '0.16s' }" v-html="m.desc"></p>
          <a href="#" class="mission-link reveal" :style="{ transitionDelay: '0.24s' }">
            查看任务详情
            <span class="mission-link-arrow"></span>
          </a>
        </div>
      </section>
    </div>

    <!-- Part 8: Footer CTA -->
    <footer class="footer-cta">
      <div class="footer-eyebrow">METTA · EOS MISSIONS</div>
      <h2 class="footer-title reveal">加入下一场<br>极限任务</h2>
      <p class="footer-sub reveal" style="transition-delay:0.08s;">
        EOS 任务名额有限，全球同步开放报名。准备好了吗？
      </p>
      <div class="footer-btns reveal" style="transition-delay:0.16s;">
        <a href="#" class="btn-light">立即报名</a>
        <span @click="$router.push({ name: 'MettaCommunity' })" class="btn-outline-light">探索社区</span>
      </div>
      <div class="footer-bottom reveal" style="transition-delay:0.24s;">
        <div class="footer-logo">METTA</div>
        <div class="footer-copy">© 2026 麦塔之境. All rights reserved.</div>
      </div>
    </footer>
  </div>
</template>

<script>
import { videoObserver, destroyVideoObserver } from '../utils/videoPlayObserver'
let observer = null;
export default {
  name: 'EosMissions',
  mounted() {
    videoObserver('HeroVideo');
    this.initScrollAnimations();
  },
  beforeDestroy() {
    if (observer) {
      observer.disconnect()
      observer = null
    }
    destroyVideoObserver()
  },
  data() {
    return {
      imgUrlPrefix: '/assets/images/eos/', // 图片地址前缀
      videoUrl: 'https://sixeco-jmk.oss-cn-hangzhou.aliyuncs.com/assets-test/video/stargazer001world.mp4',
      missions: [
        {
          id: 1,
          img: 'cbmh.jpg',
          side: 'left',
          label: 'MISSION 01',
          title: '纯白迷航',
          desc: '一切参照物在此消失，方向感将被彻底重置。<br />在纯白的虚空中，唯有内心的罗盘还在转动。'
        },
        {
          id: 2,
          img: 'rrbj.jpg',
          side: 'right',
          label: 'MISSION 02',
          title: '柔软边界',
          desc: '地形在此没有硬边，每一步落脚都在重新定义路线。<br />适应，是穿越这里唯一的方式。'
        },
        {
          id: 3,
          img: 'slzl.jpg',
          side: 'left',
          label: 'MISSION 03',
          title: '失路之林',
          desc: '没有路的地方才是真正的起点。<br />林间的每一条缝隙，都是一个尚未被命名的方向。'
        },
        {
          id: 4,
          img: 'ldzj.jpg',
          side: 'right',
          label: 'MISSION 04',
          title: '流动之境',
          desc: '地貌在持续变化，静止是一种错觉。<br />学会随流而动，而非对抗它。'
        },
        {
          id: 5,
          img: 'cxcl.jpg',
          side: 'left',
          label: 'MISSION 05',
          title: '潮线撤离',
          desc: '窗口正在收窄，每一秒都是决策。<br />速度与判断，在此同等重要。'
        },
        {
          id: 6,
          img: 'fszm.jpg',
          side: 'right',
          label: 'MISSION 06',
          title: '风石之门',
          desc: '最后的关卡，也是最古老的考验。<br />穿过这扇门，你将抵达另一种理解。'
        },
      ],
      gradients: [
        { overlay: 'linear-gradient(to right, rgba(8,8,8,0.92) 0%, rgba(8,8,8,0.55) 55%, rgba(8,8,8,0.1) 100%)', fallback: 'linear-gradient(135deg, #0a0d0a 0%, #080808 50%, #0d100a 100%)' },
        { overlay: 'linear-gradient(to left, rgba(8,8,8,0.92) 0%, rgba(8,8,8,0.55) 55%, rgba(8,8,8,0.1) 100%)',  fallback: 'linear-gradient(135deg, #080d14 0%, #080808 50%, #0a0e14 100%)' },
        { overlay: 'linear-gradient(to right, rgba(8,8,8,0.92) 0%, rgba(8,8,8,0.55) 55%, rgba(8,8,8,0.1) 100%)', fallback: 'linear-gradient(135deg, #0a0a14 0%, #080808 50%, #100a10 100%)' },
        { overlay: 'linear-gradient(to left, rgba(8,8,8,0.92) 0%, rgba(8,8,8,0.55) 55%, rgba(8,8,8,0.1) 100%)',  fallback: 'linear-gradient(135deg, #070e07 0%, #080808 50%, #0a0f08 100%)' },
        { overlay: 'linear-gradient(to right, rgba(8,8,8,0.92) 0%, rgba(8,8,8,0.55) 55%, rgba(8,8,8,0.1) 100%)', fallback: 'linear-gradient(135deg, #0e0e12 0%, #080808 50%, #0e1014 100%)' },
        { overlay: 'linear-gradient(to left, rgba(8,8,8,0.92) 0%, rgba(8,8,8,0.55) 55%, rgba(8,8,8,0.1) 100%)',  fallback: 'linear-gradient(135deg, #080810 0%, #080808 50%, #0e080e 100%)' },
      ]
    };
  },
  methods: {
    initScrollAnimations() {
      const revealEls = document.querySelectorAll('.reveal');
      observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

      revealEls.forEach(el => observer.observe(el));
    }
  }
};
</script>

<style lang="less" scoped>
@bg:    #080808;
@card:  #111111;
@bdr:   rgba(255,255,255,0.1);
@ink:   #f0ede8;
@mid:   #a0a09e;
@mute:  #606060;
@glass: rgba(8,8,8,0.72);
.eos-missions-page {
  background: @bg;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 300;
  color: @ink;
  overflow-x: hidden;
  /* ── BACK BUTTON ── */
  .back-btn {
    position: fixed;
    top: 28px; left: 36px;
    z-index: 900;
    display: flex; align-items: center; gap: 10px;
    font-size: 10px; letter-spacing: 2.5px; text-transform: uppercase;
    color: rgba(255,255,255,0.55);
    text-decoration: none;
    font-family: 'Roboto Mono', monospace;
    font-weight: 300;
    transition: color 0.2s;
    cursor: pointer;
    &:hover { color: rgba(255,255,255,0.9); }
    svg { flex-shrink: 0; }
  }

  /* ── HERO ── */
  .hero {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    display: flex; align-items: flex-end;
    .hero-video {
      position: absolute; inset: 0;
      width: 100%; height: 100%;
      object-fit: cover;
      z-index: 0;
    }

    .hero-overlay {
      position: absolute; inset: 0;
      background: linear-gradient(
        to top,
        rgba(8,8,8,0.92) 0%,
        rgba(8,8,8,0.45) 40%,
        rgba(8,8,8,0.15) 70%,
        rgba(8,8,8,0.3) 100%
      );
      z-index: 1;
    }

    .hero-fallback {
      position: absolute; inset: 0;
      background: linear-gradient(160deg, #0e1018 0%, #080808 45%, #111820 100%);
      z-index: 0;
    }

    .hero-content {
      position: relative; z-index: 2;
      width: 100%;
      padding: 0 60px 72px;
      display: flex; flex-direction: column; align-items: center; text-align: center;
    }

    .hero-eyebrow {
      font-family: 'Roboto Mono', monospace;
      font-size: 9px; letter-spacing: 4px; text-transform: uppercase;
      color: rgba(255,255,255,0.4);
      margin-bottom: 20px;
    }

    .hero-title {
      font-size: clamp(52px, 7vw, 88px);
      font-weight: 100;
      letter-spacing: -2px;
      line-height: 1;
      color: @ink;
      margin-bottom: 24px;
    }

    .hero-sub {
      font-size: 13px;
      font-weight: 300;
      color: rgba(240,237,232,0.55);
      letter-spacing: 0.5px;
      max-width: 440px;
      line-height: 1.7;
      margin-bottom: 36px;
    }

    .hero-scroll {
      font-family: 'Roboto Mono', monospace;
      font-size: 8px; letter-spacing: 3px; text-transform: uppercase;
      color: rgba(255,255,255,0.25);
      display: flex; flex-direction: column; align-items: center; gap: 10px;
    }
    .hero-scroll-line {
      width: 1px; height: 36px;
      background: linear-gradient(to bottom, rgba(255,255,255,0.25), transparent);
    }
  }



  /* ── MISSIONS ── */
  .mission {
    position: relative;
    width: 100%;
    min-height: 90vh;
    display: flex; align-items: center;
    overflow: hidden;
    border-top: 1px solid @bdr;

    .mission-bg {
      position: absolute; inset: 0;
      background-size: cover;
      background-position: center;
      z-index: 0;
      transition: transform 0.8s ease;
    }
    
    &:hover .mission-bg { 
      transform: scale(1.02); 
    }

    .mission-fallback-bg {
      position: absolute; inset: 0;
      z-index: 0;
    }

    .mission-overlay {
      position: absolute; inset: 0;
      z-index: 1;
    }

    .mission-content {
      position: relative; z-index: 2;
      padding: 100px 80px;
      max-width: 560px;
    }

    &.layout-right .mission-content {
      margin-left: auto;
    }

    .mission-num {
      font-family: 'Roboto Mono', monospace;
      font-size: 10px; letter-spacing: 3px;
      color: rgba(255,255,255,0.35);
      margin-bottom: 24px;
      display: flex; align-items: center; gap: 12px;
      &::after {
        content: '';
        display: block;
        width: 32px; height: 1px;
        background: rgba(255,255,255,0.2);
      }
    }

    .mission-tag {
      display: inline-block;
      font-family: 'Roboto Mono', monospace;
      font-size: 8px; letter-spacing: 2.5px; text-transform: uppercase;
      color: rgba(255,255,255,0.45);
      border: 1px solid rgba(255,255,255,0.15);
      padding: 5px 12px;
      margin-bottom: 20px;
    }

    .mission-title {
      font-size: clamp(28px, 3.5vw, 48px);
      font-weight: 100;
      letter-spacing: -1px;
      line-height: 1.15;
      color: @ink;
      margin-bottom: 20px;
    }

    .mission-desc {
      font-size: 13px;
      font-weight: 300;
      line-height: 1.8;
      color: rgba(240,237,232,0.6);
      margin-bottom: 36px;
      max-width: 420px;
    }

    .mission-stat {
      display: flex; gap: 36px;
      margin-bottom: 36px;
    }
    .stat-val {
      font-family: 'Roboto Mono', monospace;
      font-size: 22px; font-weight: 300;
      letter-spacing: -0.5px;
      color: @ink;
      line-height: 1;
      margin-bottom: 5px;
    }
    .stat-label {
      font-size: 9px; letter-spacing: 2px; text-transform: uppercase;
      color: rgba(240,237,232,0.35);
    }

    .mission-link {
      font-size: 9px; letter-spacing: 2.5px; text-transform: uppercase;
      color: rgba(240,237,232,0.55);
      text-decoration: none;
      font-family: 'Roboto Mono', monospace;
      font-weight: 300;
      display: inline-flex; align-items: center; gap: 10px;
      transition: color 0.2s;
      border: none; background: none; cursor: pointer;
      &:hover { color: @ink; }
    }
    
    .mission-link-arrow {
      width: 20px; height: 1px;
      background: currentColor;
      position: relative;
      transition: width 0.25s ease;
      &::after {
        content: '';
        position: absolute;
        right: 0; top: -3px;
        width: 6px; height: 6px;
        border-right: 1px solid currentColor;
        border-top: 1px solid currentColor;
        transform: rotate(45deg);
      }
    }
    
    .mission-link:hover .mission-link-arrow { 
      width: 32px; 
    }
  }

  /* ── FOOTER CTA ── */
  .footer-cta {
    background: @bg;
    border-top: 1px solid @bdr;
    padding: 120px 60px;
    text-align: center;
    display: flex; flex-direction: column; align-items: center;
    .footer-eyebrow {
      font-family: 'Roboto Mono', monospace;
      font-size: 9px; letter-spacing: 4px; text-transform: uppercase;
      color: rgba(255,255,255,0.3);
      margin-bottom: 24px;
    }

    .footer-title {
      font-size: clamp(36px, 5vw, 64px);
      font-weight: 100;
      letter-spacing: -2px;
      color: @ink;
      line-height: 1.1;
      margin-bottom: 20px;
    }

    .footer-sub {
      font-size: 13px;
      font-weight: 300;
      color: rgba(240,237,232,0.45);
      max-width: 400px;
      line-height: 1.7;
      margin-bottom: 48px;
    }
    .footer-btns {
      display: flex; gap: 14px; align-items: center; flex-wrap: wrap; justify-content: center;
    }

    .btn-light {
      font-size: 9px; letter-spacing: 2px; text-transform: uppercase;
      color: @bg; background: @ink; border: 1px solid @ink;
      padding: 14px 36px; font-family: inherit; font-weight: 300; cursor: pointer;
      transition: opacity 0.15s;
      text-decoration: none; display: inline-block;
      &:hover { opacity: 0.85; }
    }

    .btn-outline-light {
      font-size: 9px; letter-spacing: 2px; text-transform: uppercase;
      color: rgba(240,237,232,0.6); background: transparent;
      border: 1px solid rgba(255,255,255,0.15);
      padding: 14px 36px; font-family: inherit; font-weight: 300; cursor: pointer;
      transition: all 0.15s;
      text-decoration: none; display: inline-block;
      &:hover { color: @ink; border-color: rgba(255,255,255,0.45); }
    }

    .footer-bottom {
      margin-top: 100px;
      padding-top: 32px;
      border-top: 1px solid @bdr;
      width: 100%;
      display: flex; align-items: center; justify-content: space-between;
      flex-wrap: wrap; gap: 16px;
    }
    .footer-logo {
      font-family: 'Roboto Mono', monospace;
      font-size: 10px; letter-spacing: 4px; text-transform: uppercase;
      color: rgba(255,255,255,0.25);
    }

    .footer-copy {
      font-size: 10px; letter-spacing: 1px;
      color: rgba(255,255,255,0.18);
    }
  }

  /* ── FADE-UP ANIMATION ── */
  .reveal {
    opacity: 0 !important;
    transform: translateY(16px) !important;
    transition: opacity 0.5s ease, transform 0.5s ease !important;
    &.visible {
      opacity: 1 !important;
      transform: translateY(0) !important;
    }
  }
}
</style>